import React from "react";
import { ActivityIndicator, Platform, ScrollView, Text, TouchableOpacity, View } from "react-native";
import { PnmacModal } from "../../index";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CloseTwoToneIcon from "@material-ui/icons/CloseTwoTone";
import saveFilePDF from '../../saveFilePDF';
import { textStyle } from '../../v2/theme';
var AntDesign = function () {
  return /*#__PURE__*/React.createElement(View, null);
};
if (Platform.OS !== "web") {
  try {
    AntDesign = require("react-native-vector-icons/AntDesign").default;
  } catch (error) {}
}
export default function ExpanderComponent(props) {
  var _a, _b;
  var _c = React.useState(false),
    expanded = _c[0],
    setExpanded = _c[1];
  var _d = React.useState(false),
    loading = _d[0],
    setLoading = _d[1];
  var updateDocs = function () {
    setExpanded(!expanded);
  };
  var fetchModFormPdf = function (cloudDocumentId, docType, fileName) {
    var _a = props.layout,
      selectedLoanNumber = _a.selectedLoanNumber,
      pennyHomeUrl = _a.pennyHomeUrl,
      token = _a.token,
      mobile = _a.mobile;
    var body = JSON.stringify({
      docId: cloudDocumentId,
      loanId: selectedLoanNumber,
      docType: docType,
      filName: fileName
    });
    var url = pennyHomeUrl + "api/modification/get_download_mod_conditions";
    saveFilePDF({
      url: url,
      body: body,
      method: 'POST',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        'Authorization': "Bearer ".concat(token)
      },
      fileName: fileName,
      callBack: function () {
        return setLoading(false);
      }
    });
  };
  return /*#__PURE__*/React.createElement(View, null, ((_a = props === null || props === void 0 ? void 0 : props.uploadedDocuments) === null || _a === void 0 ? void 0 : _a.length) > 0 ? /*#__PURE__*/React.createElement(TouchableOpacity, {
    "aria-label": "Click to upload document",
    id: "uploadedDocs",
    onPress: function () {
      return updateDocs();
    }
  }, Platform.OS === "web" ? /*#__PURE__*/React.createElement(View, {
    style: {
      padding: 5,
      borderWidth: 1,
      alignSelf: "baseline",
      marginVertical: 6
    }
  }, /*#__PURE__*/React.createElement(ChevronRightIcon, null)) : /*#__PURE__*/React.createElement(AntDesign, {
    name: "rightsquareo",
    color: "#000",
    size: 30,
    style: {
      marginVertical: 8
    }
  }), /*#__PURE__*/React.createElement(View, null)) : null, /*#__PURE__*/React.createElement(PnmacModal, {
    "aria-labelledby": "transition-modal-title",
    "aria-describedby": "transition-modal-description",
    open: loading,
    closeAfterTransition: true
  }, /*#__PURE__*/React.createElement(ActivityIndicator, {
    size: "large"
  })), /*#__PURE__*/React.createElement(PnmacModal, {
    open: expanded,
    onClose: function () {
      return setExpanded(false);
    },
    "aria-label": "BioMetric Popup"
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      backgroundColor: "#ccffcc",
      height: '70%',
      width: Platform.OS === 'web' ? '50%' : '80%',
      alignSelf: 'center'
    }
  }, /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: function () {
      return setExpanded(false);
    },
    style: {
      alignSelf: "flex-end",
      margin: 20
    }
  }, Platform.OS === "web" ? /*#__PURE__*/React.createElement(CloseTwoToneIcon, null) : /*#__PURE__*/React.createElement(AntDesign, {
    name: "close",
    size: 20
  })), /*#__PURE__*/React.createElement(ScrollView, null, (_b = props === null || props === void 0 ? void 0 : props.uploadedDocuments) === null || _b === void 0 ? void 0 : _b.map(function (w, i) {
    return /*#__PURE__*/React.createElement(TouchableOpacity, {
      id: "document" + w.cloudDocumentId,
      key: i,
      style: {
        cursor: "pointer",
        borderWidth: 1,
        padding: 15,
        marginHorizontal: 20,
        marginBottom: 10
      },
      onPress: function () {
        fetchModFormPdf(w.cloudDocumentId, "pdf", w.name);
        setExpanded(false);
        setTimeout(function () {
          setLoading(true);
        }, 300);
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: textStyle.defaultTextDescription
    }, w.name || "No Name Provided"));
  })))));
}